class SwitchTab extends HTMLElement{
    connectedCallback(){
        const headings = this.querySelectorAll(".wt-product__switch-tab__headers > button > span");
        const contents = this.querySelectorAll(".wt-product__switch-tab__contents > div");
        headings[0].classList.add('active');
        contents[0].classList.add('active');

        headings.forEach((heading, index) => {
            heading.addEventListener('click', () => {
                contents.forEach(p => p.classList.remove('active'));
                headings.forEach(h => h.classList.remove('active'));
                contents[index].classList.add('active');
                headings[index].classList.add('active');
            });
            });
    }
}

customElements.define('switch-tab', SwitchTab);